
import { api } from './api';

export const groupApi = api.injectEndpoints({
  endpoints: (build) => ({
    getGroup: build.query({
      query: (id) => ({
        url: `group/${id}`,
      }),
      providesTags: (_result, _err, id) => [{ type: 'Groups', id }],
    }),
    updateGroup: build.mutation({
      query: ({id, form}) => ({
        url: `group/${id}`,
        method: 'PUT',
        body: JSON.stringify({...form}),
      }),
      invalidatesTags: (result, error) => {
        return error ? [] : [{ type: 'Groups', id: 'LIST' }]
      },
    }),
    createGroup: build.mutation({
      query: (form) => ({
        url: 'group',
        method: 'POST',
        body: JSON.stringify({...form}),
      }),
      invalidatesTags: (result, error) => error ? [] : [{ type: 'Groups', id: 'LIST' }],
    }),
    deleteGroup: build.mutation({
      query: (id) => ({
        url: `group/${id}`,
        method: 'DELETE',
      }),
      invalidatesTags: (result, error) => error ? [] : [{ type: 'Groups', id: 'LIST' }],
    }),
  }),
})

export const {
  useGetGroupQuery,
  useLazyGetGroupQuery,
  useUpdateGroupMutation,
  useCreateGroupMutation,
  useDeleteGroupMutation,
} = groupApi;

